import click from '@mailobj-browser/front/js/events/types/click.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import * as utilities from '#utilities/js/styles.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: (
    favorites
  ) => {
    const { ownerDocument } = favorites
    const divAdbook = one('.ea_mail__send_adbook_adbook', ownerDocument)
    const divFavorites = one('.ea_mail__send_adbook_favorites', ownerDocument)
    const divSpaces = one('.ea_mail__send_adbook_spaces', ownerDocument)
    if (divFavorites && divFavorites.classList.contains(utilities.modifiers.display.none)) {
        divFavorites.classList.toggle(utilities.modifiers.display.none)
      if (divAdbook && !divAdbook.classList.contains(utilities.modifiers.display.none)) {
        divAdbook.classList.toggle(utilities.modifiers.display.none)
      }
      if (divSpaces && !divSpaces.classList.contains(utilities.modifiers.display.none)) {
        divSpaces.classList.toggle(utilities.modifiers.display.none)
      }
    }
  }
})

export default favorites => {
  onClick.listen(favorites)
}
